<template>
  <div class="upload">
    <el-upload
      ref="uploadRefs"
      :action="action"
      :multiple="multiple"
      :limit="limit"
      :accept="accept"
      :show-file-list="false"
      :headers="headers"
      :data="data"
      :on-progress="onProgress"
      :on-success="onSuccess"
      :on-exceed="onExceed"
      :on-error="onError"
    >
      <slot></slot>
    </el-upload>
    <el-dialog
      v-if="showProgress && fileList.length"
      title="上传进度"
      :visible.sync="visible"
      top="20vh"
      :close-on-click-modal="false"
      width="500px"
      :modal="false"
      :before-close="onClose"
    >
      <div class="file-list">
        <div class="mb-20" v-for="(item, index) in fileList" :key="index">
          <div>{{ item.name }}</div>
          <div class="flex-1">
            <el-progress :percentage="parseInt(item.percentage)"></el-progress>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import config from "@/config";

export default {
  data() {
    return {
      action: `${process.env.VUE_APP_BASE_URL}/admapi/upload/${this.type}`,
      visible: false,
      fileList: [],
    };
  },
  props: {
    // 上传文件类型
    type: {
      type: String,
      default: "image",
    },
    // 是否支持多选
    multiple: {
      type: Boolean,
      default: true,
    },
    // 多选时最多选择
    limit: {
      type: Number,
      default: 10,
    },
    // 文件选择器允许的 MIME 类型或扩展名
    accept: {
      type: String,
      default: "",
    },
    // 上传时的额外参数
    data: {
      type: Object,
      default: () => ({}),
    },
    // 是否显示上传进度
    showProgress: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headers() {
      return {
        token: this.$store.getters.token,
        version: config.version,
      };
    },
  },
  methods: {
    onProgress(event, file, fileList) {
      this.visible = true;
      this.fileList = fileList;
    },
    onSuccess(response, file, fileList) {
      const allSuccess = fileList.every((item) => item.status === "success");
      if (allSuccess) {
        this.$refs.uploadRefs.clearFiles();
        this.visible = false;
      }
      this.$emit("change");
      if (response.code === 400) {
        this.$message.error(response.message);
      }
      if (response.code === 200) {
        this.$emit("finish", { url: response.data.url });
      }
    },
    onError(error, file) {
      this.$message.error(`${file.name}文件上传失败`);
      this.$refs.uploadRefs.abort();
      this.visible = false;
      this.$emit("change");
      this.$emit("error");
    },
    onExceed() {
      this.$message.error("超出上传上限，请重新上传");
    },
    onClose() {
      this.$refs.uploadRefs.abort();
      this.$refs.uploadRefs.clearFiles();
      this.visible = false;
    },
  },
};
</script>

<style scoped lang="scss"></style>
